import {cx} from "emotion";
import * as React from "react";

import {cc}               from "@Common/react/callback-chain";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {fragments}        from "@Common/react/fragments";
import {UseState}         from "@Common/react/use-state";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {groupItemEditors} from "@Common/ui-components/heavy/item-options/minors/group-item-editors";
import {buildUrlQuery}    from "@Common/utils/build-url-query";

import {EnsureItemAddedToCart} from "../../../common/logic/cart-logic/ensure-item-added-to-cart";

export const ProceedButton = ({itemOptions, showErrors, query, item}) => cs(
    consumeContext("apis"),
    consumeContext("routerHistory"),
    consumeContext("userLevels"),
    ["ensureItemAddedToCart", (_, next) => EnsureItemAddedToCart({next})],
    ["checkingOut", (_, next) => UseState({next})],
    ["itemEditor", (_, next) => next(groupItemEditors([itemOptions.itemEditor].filter(v=>v)))],

    // ({itemEditor}, next) => fragments(
    //     next(),
    //     isDevQuan() && (() => {
    //         console.log(itemEditor.prepareSave(item)?.newValue?.tracking?.informedDelivery)
    //         return null;
    //     })(),
    // ),
    ({checkingOut, itemEditor, apis, ensureItemAddedToCart, routerHistory, userLevels}) => (
        <button {...{
            className: cx({disabled: !itemEditor.valid || itemEditor.loading}),
            disabled: checkingOut.value,
            onClick: () => cc([
                async (_, next) => {
                    if (itemEditor.loading) {
                        showErrors.onChange(true);
                        alert("Loading data...");
                    } else if (!itemEditor.valid) {
                        showErrors.onChange(true);
                        itemEditor.errorsHandling?.highlightErrors?.();
                    } else {
                        if (await itemEditor.showWarnings()) {
                            await next();
                        }
                    }
                },
                async (_, next) => {
                    checkingOut.onChange(true);
                    try {
                        await next();
                    } finally {
                        checkingOut.onChange(false);
                    }
                },
                async (_, next) => {
                    try {
                        const savedItem = await next();
                        if (query?.referrer === "approval-requests") {
                            let cartId = query.id_cart ?? query.cart_id;
                            if (cartId == null) {
                                alert("Error: No cart id found");
                                return;
                            }

                            if (cartId === 'new') {
                                const cart = await apis.next.cart.createApprovalCart();
                                if(cart?.result ==='failure') {
                                    alert(cart?.errors?.msg);
                                    return;
                                }

                                const savedCart = await apis.next.cart.addItemsToCart({cartId: cart.cartId, itemIds: [savedItem.itemId]});
                                if (savedCart.result === 'failure' ) {
                                    alert(savedCart.errors.msg);
                                    routerHistory.push(`/distribution-options/order/${item.itemId}` + buildUrlQuery({
                                        referrer: query.referrer,
                                    }));
                                    return;
                                }

                                cartId = savedCart.cartId;
                                window.history.replaceState(window.history.state,null,
                                    `/app/distribution-options/order/${item.itemId}` + buildUrlQuery({
                                        id_cart: cartId,
                                        referrer: "approval-requests",
                                    })
                                );
                            }

                            routerHistory.push(`/checkout/${cartId}` + buildUrlQuery({
                                referrer: query.referrer,
                            }));
                        } else {
                            const {cartId, result, msg} = await ensureItemAddedToCart({
                                item: savedItem,
                            });

                            if( result==='failure' )
                            {
                                alert(msg)
                                return;
                            }

                            const onSavedResult = await (async () => {
                                // Modules like ship-additional will need to do extra action after the item is saved
                                for (const onSaved of itemOptions.onSaveds ?? []) {
                                    if (onSaved && await onSaved({item: savedItem, cartId}) === false) {
                                        return false;
                                    }
                                }
                                return true;
                            })();

                            if (!onSavedResult) {
                                showErrors.onChange(true);
                            } else {
                                await apis.next.session.clearSessionOrder();
                                if (userLevels.listSelected) {
                                    userLevels.reload();
                                }
                                routerHistory.push(`/checkout/${cartId}`);
                            }
                        }
                    } catch (e) {
                        alert(e);
                    }
                },
                async () => {
                    if (!itemEditor.changed) {
                        return item;
                    }

                    const {newValue, onSaved} = itemEditor.prepareSave(item);
                    const result = await apis.next.item.updateItem(newValue);
                    if (result?.errors) {
                        throw result.errors?.msg ?? "Unknown error";
                    }
                    await onSaved();
                    return result;
                },
            ]),
            "xd-qa-type": "button",
            "xd-qa-name": "Proceed to Checkout"
        }}>
            Proceed to Checkout
        </button>
    )
);
